import { defineComponent, shallowRef } from "vue";
import TheHeader from "./vue/header/TheHeader.vue";
import AppOverlay from "./vue/overlay/AppOverlay.vue";
import { SET_IS_OVERLAY_VISIBLE, SET_JWT_TOKEN } from "./store/AppStoreMutations";
import { AuthApi } from "./api/AuthApi";
import { Auth } from "./auth/Auth";
export default defineComponent({
    components: {
        TheHeader,
        AppOverlay
    },
    data: function () {
        return {
            isVisibleOverlay: false,
            overlay: {
                srcIcon: "svg/account.svg",
                title: "Hello",
                body: {}
            }
        };
    },
    watch: {
        isVisibleOverlay: function () {
            this.$store.commit(SET_IS_OVERLAY_VISIBLE, this.isVisibleOverlay);
        }
    },
    methods: {
        setOverlay: function (srcIcon, title, body) {
            this.isVisibleOverlay = true;
            this.overlay.srcIcon = srcIcon;
            this.overlay.title = title;
            this.overlay.body = shallowRef(body);
        },
    },
    mounted: function () {
        const token = this.$store.getters.getJwtToken;
        if (Auth.isValidJwtToken(token) && token != null) {
            AuthApi.getRefreshToken(token).then((newToken) => {
                this.$store.commit(SET_JWT_TOKEN, newToken);
            }).catch((e) => console.error(e));
        }
    }
});
